import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import MyRequests from 'containers/AmcDetailsPage/PacRequestsTab/MyRequests';
import { StyledtBlocWrapper } from 'containers/AmcDetailsPage/FollowUpMyRequestsTab/styles';
import { Grid } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import messages from 'containers/AmcDetailsPage/messages';
import { translate } from 'helpers/intl';
import ModalOrganisme from 'components/ModalOrganisme';
import {
  getAmcDetailsPageSelectedTabValue,
  getIsModalOrganismeChoice,
} from 'store/global/selectors';
import {
  closeModalOrganisme,
  openModalOrganisme,
  setAMCDetailsPageBreadcrumbsPath,
} from 'store/global/actions';
import FoldersList from 'containers/AMCDashboard/DeclareFolderProcess/FoldersList';
import { mappedOrganismeList } from 'containers/AMCDashboard/DeclareFolderProcess/mapping';
import { getOrganismesPAC } from 'store/pac/actions';
import { StoreContext } from 'utils/contextStore';
import { StyledCaption } from '../MyRefundsTab/styles';

const PacRequestsTab = (props: {
  intl: IntlShape;
  pacOrganismes: any;
  openModalOrganisme: Function;
  closeModalOrganisme: Function;
  setAMCDetailsPageBreadcrumbsPath: Function;
  getOrganismesPAC: Function;
  isOpenModalOrganismeChoice: boolean;
  selectedTabValue: number;
}) => {
  const [organisme, setOrganisme] = React.useState(null);

  const { organismeListPacState } = React.useContext(StoreContext);
  const organismeListPac = organismeListPacState?.organismeListPac;

  useEffect(() => {
    /* istanbul ignore next */
    props.openModalOrganisme();
  }, []);

  return (
    <GaLoadHOC
      category={EVENT_CATEGORIES.AMC_DETAILS}
      label="Suivi de mes demandes_Tab 2_Suivi de mes demandes"
    >
      <>
        <Grid container alignItems="center" justify="flex-end">
          <Grid item>
            <StyledCaption>
              {translate({ ...messages.filter }, props)}
            </StyledCaption>
          </Grid>
          <Grid item>
            <FilterListIcon
              onClick={
                /* istanbul ignore next */ () => props.openModalOrganisme()
              }
            />
          </Grid>
        </Grid>
        <StyledtBlocWrapper height="auto">
          <MyRequests selectedOrganisme={organisme} />
        </StyledtBlocWrapper>
        <ModalOrganisme
          headerTitle={props.intl.formatMessage({
            id: 'pac.suivi.declaration.button.title',
          })}
          closeModalOrganismeChoice={
            /* istanbul ignore next */ () => {
              props.closeModalOrganisme();
            }
          }
          isOpen={props.isOpenModalOrganismeChoice}
          content={
            <FoldersList
              FoldersListItems={mappedOrganismeList(props.pacOrganismes)}
              titleCard={props.intl.formatMessage({
                id: 'Home_text_Health_select_organisme',
              })}
              radioButtonName="organisme"
            />
          }
          setAMCDetailsPageBreadcrumbsPath={setAMCDetailsPageBreadcrumbsPath}
          setOrganisme={setOrganisme}
          organismeList={organismeListPac}
        />
      </>
    </GaLoadHOC>
  );
};
const mapStateToProps = createStructuredSelector<
  any,
  {
    isOpenModalOrganismeChoice: boolean;
    selectedTabValue: number;
  }
>({
  isOpenModalOrganismeChoice: getIsModalOrganismeChoice,
  selectedTabValue: getAmcDetailsPageSelectedTabValue,
});

const mapDispatchToProps = {
  openModalOrganisme,
  closeModalOrganisme,
  setAMCDetailsPageBreadcrumbsPath,
  getOrganismesPAC,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(PacRequestsTab));
